import styled from "styled-components"
import { Loading } from "@xingternal/winery-ui/lib/Loading"

const KpiOverviewLoading = styled(Loading)``

KpiOverviewLoading.defaultProps = {
  m: 4,
}

export default KpiOverviewLoading
